import type { SvgType } from './types'

export default function Pdf({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M8.525 18.51L4.99 14.973 17.364 2.6a.5.5 0 01.707 0L20.9 5.428a.5.5 0 010 .707L8.525 18.51zm-.707.707L4.283 15.68l-1.768 5.303 5.303-1.767z"
        clipRule="evenodd"
      />
      <mask width={20} height={19} x={2} y={2} maskUnits="userSpaceOnUse">
        <path
          fill={fill}
          fillRule="evenodd"
          d="M8.525 18.51L4.99 14.973 17.364 2.6a.5.5 0 01.707 0L20.9 5.428a.5.5 0 010 .707L8.525 18.51zm-.707.707L4.283 15.68l-1.768 5.303 5.303-1.767z"
          clipRule="evenodd"
        />
      </mask>
    </svg>
  )
}
